(function() { module.exports = window["Bernie_l10nBundle_pt_PT"]; }());